var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.dateViewOptions},model:{value:(_vm.timeSelection),callback:function ($$v) {_vm.timeSelection=$$v},expression:"timeSelection"}})}
var staticRenderFns = []

export { render, staticRenderFns }